import './App.css';
import React from 'react';
import { AppRouter } from "./routes/AppRouter";
import Loader from "./pages/loader";

// Keycloak
import { ReactKeycloakProvider } from "@react-keycloak/web";
import keycloak from "./Keycloak";
import {ClientProvider} from "./utilities/ClientProvider";

function App() {
    return (
        <ReactKeycloakProvider
            authClient={keycloak}
            initOptions={{
                onLoad: 'check-sso',
                silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`
            }}
            LoadingComponent={<Loader />}>
            <React.StrictMode>
            <ClientProvider>
                <AppRouter />
            </ClientProvider>
            </React.StrictMode>
        </ReactKeycloakProvider>
    );
}

export default App;
